import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { updateSuggestionStatus } from '../ui/utils/api';
import type { DiscardAllSuggestionsAction } from './types';

export const discardAllSuggestionsAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => DiscardAllSuggestionsAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
		if (!suggestionById || suggestionById.size === 0) {
			return false;
		}

		const ids = Array.from(suggestionById.keys());

		api?.core?.actions.execute(({ tr }) => {
			tr.setMeta(aiSuggestionsPluginKey, { action: 'CLEAR_SUGGESTIONS' });
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});

		const updates = ids.map((id) => ({ id, status: 'DISMISSED' as const }));

		updateSuggestionStatus({ updates });

		return true;
	};
